module.exports = __webpack_public_path__ + "media/images/common/regist_btn_l_ov-48693ec39f744cd7d852ac114699f2e1.png";